import { CONFIG, flatMultiplier, outcomeMultiplier } from '../config.js';
import { cardsBucket, cornersBucket, hasCards, hasCorners } from './helpers.js';
const flat = flatMultiplier;
const opt = outcomeMultiplier;
const CORNERS_LINE = CONFIG.TOTAL_CORNERS_LINE;
/** Coverage-gated legs (events / stats). */
export const EVENTS_MARKETS = [
    {
        id: 'totalCorners',
        label: `Corners ${CONFIG.TOTAL_CORNERS_LINE}`,
        shortLabel: `Corners O/U ${CONFIG.TOTAL_CORNERS_LINE}`,
        kind: 'binary',
        multiplier: flat('totalCorners'),
        requires: 'stats',
        options: [
            { value: 'OVER', label: 'Over' },
            { value: 'UNDER', label: 'Under' }
        ],
        gradeable: hasCorners,
        isHit: (s, r) => !hasCorners(r)
            ? false
            : s === ((r.homeCorners ?? 0) + (r.awayCorners ?? 0) > CORNERS_LINE ? 'OVER' : 'UNDER'),
        winningLabel: (r) => !hasCorners(r)
            ? null
            : `${(r.homeCorners ?? 0) + (r.awayCorners ?? 0) > CORNERS_LINE ? 'Over' : 'Under'} ${CORNERS_LINE}`
    },
    {
        id: 'mostCorners',
        label: 'Most corners?',
        shortLabel: 'Most corners',
        kind: 'ternary',
        requires: 'stats',
        options: [
            { value: 'HOME', label: 'Home', multiplier: opt('mostCorners', 'HOME') },
            { value: 'DRAW', label: 'Equal', multiplier: opt('mostCorners', 'DRAW') },
            { value: 'AWAY', label: 'Away', multiplier: opt('mostCorners', 'AWAY') }
        ],
        teamRelative: true,
        gradeable: hasCorners,
        isHit: (s, r) => (!hasCorners(r) ? false : s === cornersBucket(r)),
        winningLabel: (r) => !hasCorners(r) ? null : cornersBucket(r) === 'DRAW' ? 'Equal' : cornersBucket(r) === 'HOME' ? 'Home' : 'Away'
    },
    {
        id: 'mostCards',
        label: 'Most cards?',
        shortLabel: 'Most cards',
        kind: 'ternary',
        requires: 'stats',
        options: [
            { value: 'HOME', label: 'Home', multiplier: opt('mostCards', 'HOME') },
            { value: 'DRAW', label: 'Equal', multiplier: opt('mostCards', 'DRAW') },
            { value: 'AWAY', label: 'Away', multiplier: opt('mostCards', 'AWAY') }
        ],
        teamRelative: true,
        gradeable: hasCards,
        isHit: (s, r) => s === cardsBucket(r),
        winningLabel: (r) => !hasCards(r) ? null : cardsBucket(r) === 'DRAW' ? 'Equal' : cardsBucket(r) === 'HOME' ? 'Home' : 'Away'
    },
    {
        id: 'scorer',
        label: 'Anytime scorer',
        shortLabel: 'Scorer',
        kind: 'player',
        multiplier: flat('scorer'),
        requires: 'events',
        // A no-show simply misses (never a void) — a result with no scorer list reads
        // as a miss for that leg, not an excluded market.
        gradeable: () => true,
        isHit: (s, r) => (r.scorerIds ?? []).includes(s),
        winningLabel: () => null
    },
    {
        id: 'redCard',
        label: 'A red card shown?',
        shortLabel: 'Red card',
        kind: 'binary',
        requires: 'events',
        options: [
            { value: 'YES', label: 'Yes', multiplier: opt('redCard', 'YES') },
            { value: 'NO', label: 'No', multiplier: opt('redCard', 'NO') }
        ],
        gradeable: (r) => r.redCard != null,
        isHit: (s, r) => s === (r.redCard ? 'YES' : 'NO'),
        winningLabel: (r) => (r.redCard == null ? null : r.redCard ? 'Yes' : 'No')
    }
];
//# sourceMappingURL=catalogEvents.js.map